/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'FAC_LEGALLY_OWNS_THE_PREMISES_BUILDINGS_THEY_OCCUPY',
        'FAC_DOES_NOT_LEGALLY_OWN_THE_BUILDINGS_PREMISES_THEY_OCCUPY',
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_rent_or_own_the_premises_they_occupy: valueSchema,
  },
}
